<template>
    <div class="card" v-if="$canIf('dids.create')">
        <form action="" method="post" @submit.prevent="createDid" id="did-form">
            <div class="card-header">
                <div class="d-flex">
                    <h4>Cadastrar Did</h4>
                </div>
            </div>
            <div class="card-body">
                <did-form
                :errors="errors"
                :did="did"
                />
            </div>
            <div class="card-footer">
                <button class="btn bg-success mr-2">Cadastrar</button>
                <router-link :to="{ name: 'Dids.Index' }" class="btn bg-danger">Voltar</router-link>
            </div>
        </form>
    </div>
</template>

<script>
import  DidForm from "@/components/views/dids/_Form";
export default {

    components: {
        'did-form': DidForm,
    },

    data(){
        return {
            errors: {},
            did: {},
        }
    },

    methods: {
        createDid() {
            var dados = new FormData(document.getElementById('did-form'));

            this.$httpApi.post('dids',dados,{
                headers: {
                    'Authorization': 'Bearer '+sessionStorage.getItem('Auth_Token'),
                },
            }).then(res => {
                this.$router.push({ name: 'Dids.Index' })
                this.$store.dispatch('criarMensagem',[
                    res.data.message,
                    'success'
                ])
            }).catch(res => {
                if(res.response.data.errors){
                    this.errors = res.response.data.errors
                }
                this.$store.dispatch('exibeErro', [
                    res.response
                ])
            });
        },
    }

}
</script>

<style>

</style>